module.exports = __webpack_public_path__ + "static/media/cover.f165920b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover.jpg
// module id = 1354
// module chunks = 0